import { Link } from "@/lib/router";
import { CITIES, SECTIONS } from "@/data/sections";
import { Logo } from "./Header";

export function Footer() {
  return (
    <footer className="mt-12 bg-ink text-white">
      <div className="mx-auto max-w-[1240px] px-4 py-10">
        <div className="flex flex-col items-start justify-between gap-4 border-b border-white/20 pb-6 md:flex-row md:items-end">
          <Link href="/" aria-label="BrickBharat home">
            <Logo className="text-5xl md:text-6xl" />
          </Link>
          <p className="max-w-md font-[family-name:var(--font-body)] text-[15px] text-white/70">
            BrickBharat covers India's homes, offices, land and the money and rules behind them, from Mumbai's towers to the
            plots of tomorrow's cities.
          </p>
        </div>

        <div className="grid grid-cols-2 gap-8 py-8 md:grid-cols-4">
          <div>
            <h3 className="kicker mb-3">Sections</h3>
            <ul className="space-y-2">
              {SECTIONS.map(s => (
                <li key={s.id}>
                  <Link href={`/section/${s.id}`} className="font-bold hover:text-brand">
                    {s.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h3 className="kicker mb-3">Cities</h3>
            <ul className="space-y-2">
              {CITIES.map(c => (
                <li key={c}>
                  <Link href={`/search?q=${encodeURIComponent(c)}`} className="font-bold hover:text-brand">
                    {c}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h3 className="kicker mb-3">Tools</h3>
            <ul className="space-y-2 font-bold">
              <li><Link href="/section/finance" className="hover:text-brand">EMI Calculator</Link></li>
              <li><Link href="/section/policy" className="hover:text-brand">RERA Guide</Link></li>
              <li><Link href="/video" className="hover:text-brand">Video</Link></li>
              <li><a href="#newsletter" className="hover:text-brand">Newsletters</a></li>
            </ul>
          </div>
          <div>
            <h3 className="kicker mb-3">BrickBharat</h3>
            <ul className="space-y-2 font-bold">
              <li><a href="mailto:editor@brickbharat.com" className="hover:text-brand">Send a Tip</a></li>
              <li><a href="mailto:ads@brickbharat.com" className="hover:text-brand">Advertise</a></li>
              <li><a href="mailto:hello@brickbharat.com" className="hover:text-brand">Contact Us</a></li>
            </ul>
          </div>
        </div>

        <p className="border-t border-white/20 pt-6 text-[12px] text-white/60">
          © {new Date().getFullYear()} BrickBharat.com. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
